module.exports = __webpack_public_path__ + "static/img/gg.db99f18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/gg.png
// module id = ivNv
// module chunks = 6